export type NotificationSchedulesTriggerDate = {
    id: number;
    name: string;
    textResourceKey: string;
}

export enum NotificationSchedulesTriggerDateEnum {
    BookingDate = 1,
    ConfirmationDate = 2,
    OptionExpirationDate = 3,
    ArrivalDate = 4,
    DepartureDate = 5,
    OfferExpirationDate = 6,
    InvoiceDueDate = 7,
    AdvanceInvoicePaymentDate = 8,
    ReservationPaymentDate = 9
}